import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { User } from "../../../../domain/user";
import { Router } from "@angular/router";
import { Socket } from "../../../../infrastructure/socket.service";
import { UI } from "../../../../services/ui.service";
import { Layout } from "../../../../domain/layouts/layout";
import { Subscription } from "rxjs";
import { ILayoutsRepository } from "../../../../domain/layouts/layouts.repository";
import { MediaInfo } from "../../../../domain/media";

@Component({
  selector: "evrideo-layout-library-item",
  templateUrl: "./layout-library-item.component.html",
  styleUrls: ["./layout-library-item.component.scss"],
})
export class LayoutLibraryItemComponent implements OnInit, OnDestroy {
  @Input()
  item: Layout;

  @Input()
  currentUser: User;

  @Input()
  viewMode = "gallery";

  menuOpen = false;
  dragged = false;

  layoutUpdatedSubscription: Subscription;

  @Output()
  deleteEmitter = new EventEmitter();

  constructor(
    private ref: ElementRef,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private socketService: Socket,
    private ui: UI,
    private _layoutRepository: ILayoutsRepository,
  ) {}

  ngOnInit() {
    this.ref.nativeElement.addEventListener(
      "dragstart",
      this.onDragStart.bind(this),
      false,
    );
    this.ref.nativeElement.addEventListener(
      "dragend",
      this.onDragEnd.bind(this),
      false,
    );

    this.layoutUpdatedSubscription =
      this._layoutRepository.layoutUpdated.subscribe(
        this.onLayoutUpdated.bind(this),
      );
  }
  onLayoutUpdated(layout: Layout) {
    if (this.item.id === layout.id) {
      this.item = layout;
      this.changeDetectorRef.markForCheck();
    }
  }

  deleteLayout() {
    this.ui.notify(this.ui.EVENTS.ShowConfirm, {
      title: "Delete layout " + this.item.name,
      message: "Are you sure about that?",
      buttons: [
        {
          title: "Yes",
          callback: this.onDeleteConfirmed.bind(this),
        },
        {
          title: "No",
          callback: this.onDeleteCancelled.bind(this),
        },
      ],
    });
  }

  onDeleteConfirmed() {
    this.deleteEmitter.emit();
  }

  onDeleteCancelled() {}

  editLayout() {
    this.router.navigate(["/layouts/edit/", this.item.id]);
  }

  onDragStart(event: DragEvent) {
    this.dragged = true;
    event.dataTransfer.setData("text/layout", JSON.stringify(this.item));
    event.dataTransfer.dropEffect = "copy";
  }

  onDragEnd(event) {
    this.dragged = false;
  }

  ngOnDestroy(): void {
    if (this.layoutUpdatedSubscription) {
      this.layoutUpdatedSubscription.unsubscribe();
    }
  }
}
